module.exports = __webpack_public_path__ + "img/icn_checkbox.4df5cefd.svg";